import { MaskedLines } from "./motion/Reveal";
import { motion } from "framer-motion";

export const PageHeader = ({ overline, titleLines, subtitle }) => (
  <section className="relative overflow-hidden bg-ink pb-16 pt-32 text-white sm:pb-24 sm:pt-40">
    <div className="pointer-events-none absolute inset-0">
      <div className="absolute -right-32 -top-32 h-[480px] w-[480px] rounded-full bg-brand/25 blur-[130px]" />
      <div className="absolute -bottom-40 left-1/4 h-[420px] w-[420px] rounded-full bg-brand/10 blur-[140px]" />
      <div className="absolute inset-x-0 bottom-0 h-px bg-gradient-to-r from-transparent via-brand/50 to-transparent" />
    </div>
    <div className="relative mx-auto max-w-[1400px] px-5 sm:px-8">
      <motion.p
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.1 }}
        className="font-mono text-xs uppercase tracking-[0.3em] text-brand"
      >
        {overline}
      </motion.p>
      <h1 className="mt-6 font-display text-5xl font-extrabold uppercase leading-[0.9] tracking-tightest text-white sm:text-7xl lg:text-8xl">
        <MaskedLines lines={titleLines} delay={0.15} />
      </h1>
      {subtitle && (
        <motion.p
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.5, duration: 0.7 }}
          className="mt-8 max-w-2xl text-lg leading-relaxed text-white/60"
        >
          {subtitle}
        </motion.p>
      )}
    </div>
  </section>
);
